import { render, staticRenderFns } from "./brave-modal.vue?vue&type=template&id=6a90b6ec"
import script from "./brave-modal.vue?vue&type=script&lang=js"
export * from "./brave-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports